import { render, staticRenderFns } from "./ApartmentEditPage.vue?vue&type=template&id=bab6be6a&"
import script from "./ApartmentEditPage.vue?vue&type=script&lang=ts&"
export * from "./ApartmentEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports